import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPipelinePlannedPlantationPlantsInputDto, PipelinePlannedPlantationPlantCreateDto, PipelinePlannedPlantationPlantDto, PipelinePlannedPlantationPlantExcelDownloadDto, PipelinePlannedPlantationPlantUpdateDto } from '../dtos/pipeline-planned-plantation-plant/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PipelinePlannedPlantationPlantService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: PipelinePlannedPlantationPlantCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationPlantDto>({
      method: 'POST',
      url: '/api/operational/pipelinePlannedPlantationPlants',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/pipelinePlannedPlantationPlants/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/pipelinePlannedPlantationPlants',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationPlantDto>({
      method: 'GET',
      url: `/api/operational/pipelinePlannedPlantationPlants/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantationPlants/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPipelinePlannedPlantationPlantsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PipelinePlannedPlantationPlantDto>>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantationPlants',
      params: { pipelinePlannedPlantationId: input.pipelinePlannedPlantationId, pipelinePlannedPlantationName: input.pipelinePlannedPlantationName, plantId: input.plantId, plantTypeId: input.plantTypeId, speciesGroupId: input.speciesGroupId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PipelinePlannedPlantationPlantExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/pipelinePlannedPlantationPlants/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, pipelinePlannedPlantationId: input.pipelinePlannedPlantationId, pipelinePlannedPlantationName: input.pipelinePlannedPlantationName, plantId: input.plantId, plantTypeId: input.plantTypeId, speciesGroupId: input.speciesGroupId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationPlantDto[]>({
      method: 'GET',
      url: '/api/operational/pipelinePlannedPlantationPlants/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  undoDelete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationPlantDto>({
      method: 'POST',
      url: `/api/operational/pipelinePlannedPlantationPlants/${id}/undo-delete`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PipelinePlannedPlantationPlantUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelinePlannedPlantationPlantDto>({
      method: 'PUT',
      url: `/api/operational/pipelinePlannedPlantationPlants/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}